import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import routes from "./ComponentRoutes";
import MainLayout from "./pages/components/MainLayout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import { TitleContext } from "./Context/TitleContext";
import { useState } from "react";
import { ToastProvider } from "./Context/ToastContext";
import { AuthProvider } from "./Context/AuthContext";
import ProtectedRoute from "./pages/auth/ProtectedRoute";
import { Helmet } from "react-helmet-async";
import ConfirmPassword from "./pages/ConfirmPassword";

function App() {

  const [title, setTitle] = useState("USAKTI"); // Judul default

  return (
    <Router>
      <ToastProvider>
        <AuthProvider>
          <TitleContext.Provider value={{ title, setTitle }}>
            <Helmet>
              <title>{title}</title>
            </Helmet>
            <Routes>
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<MainLayout />}>
                  {routes.map((route, index) => {
                    // if (route.roles.length && !route.roles.includes(userRole)) {
                    //   return (
                    //     <Route
                    //       key={index}
                    //       path={route.path}
                    //       element={<Navigate to="/login" />}
                    //     />
                    //   );
                    // }
                    return (
                      <Route
                        key={index}
                        path={route.path}
                        element={<route.component />}
                      />
                    );
                  })}
                </Route>
              </Route>
              <Route path="/login" element={<Login />} />
              <Route path="/password/reset" element={<ForgotPassword />} />
              <Route
                path="/confirm-password/:id"
                element={<ConfirmPassword />}
              />
            </Routes>
          </TitleContext.Provider>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;
